import type { AuthFailureReason } from '@cli-types/next-adapter/vercel.js'

export function authFailureMessage(reason?: AuthFailureReason): string {
  switch (reason) {
    case 'login-cancelled':
      return 'Vercel sign-in was cancelled.'
    case 'login-failed':
      return 'Could not verify your Vercel sign-in.'
    case 'timeout':
      return 'Vercel sign-in timed out.'
    case 'no-runner':
      return 'The Vercel CLI is not available.'
    default:
      return 'Could not sign in to Vercel.'
  }
}
